import { LogoIcon } from "../../assets"


const allProducts = [
//Fintech
  {
    id: 1,
    website: "https://intasend.com/",
    category: 'Fintech',
    name: "Intasend",
    logo: LogoIcon,
  },

//Social Commerce
  {
    id: 6,
    website: "https://rembekaonline.com/",
    category: 'Social Commerce',
    logo: LogoIcon,
    name: "Rembeka",
  },
  {
    id: 7,
    website: "https://lukufiti.com/",
    category: 'Social Commerce',
    logo: LogoIcon,
    name: "LukuFiti",
  },
  {
    id: 8,
    website: "https://safirisalama.com/",
    category: 'Social Commerce',
    logo: LogoIcon,
    name: "Safiri Salama",
  },

//Creator Community
 
  {
    id: 16,
    website: "https://useresolv.com/",
    category: 'Creator Community',
    name: "Resolv",
    logo: LogoIcon,
  },
  
//AI

//Moonshots & Frontier Tech
  {
    id: 21,
    website: "https://gosoftafrica.io",
    category: 'Moonshots & Frontier Tech',
    name: "GoSoft",
    logo: LogoIcon,
  },
];
export default allProducts